import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import SettingsPage from './pages/SettingsPage';
import GamePage from './pages/GamePage';
import ResultsPage from './pages/ResultsPage';
import CopyrightPage from './pages/CopyrightPage';
import PrivacyPage from './pages/PrivacyPage';
import ImprintPage from './pages/ImprintPage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/copyright" element={<CopyrightPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/imprint" element={<ImprintPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
      <div className="site-footer-bar">
        <div className="footer-inaturalist-group">
          <a href="https://www.inaturalist.org" target="_blank" rel="noopener noreferrer" className="footer-inaturalist-logo">
            <img src="/inaturalist-powered.png" alt="Powered by iNaturalist" className="footer-inaturalist" />
          </a>
          <span className="footer-inaturalist-disclaimer">
            This website uses observation data from iNaturalist. This website has no official connection with iNaturalist.
          </span>
        </div>
        <nav className="footer-links">
          <a href="https://buymeacoffee.com/plantid" target="_blank" rel="noopener noreferrer">Donate</a>
          <Link to="/about">Contact</Link>
          <Link to="/copyright">Copyright</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/imprint">Imprint</Link>
        </nav>
      </div>
    </Router>
  );
}

export default App;

